/*
**************************** 
홈페이지 톡톡박스 시리얼키 등록
*****************************
*/

import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function TokTokRegist(props) {
    const [userLogin, setUserLogin] = useState({ login_id: "", password: "", toktokSerial: "" });

    const pathData = useParams();
    const [userData, setUserData] = useState({ username: "", name: "", email: "", phone: "", address: "", subAddress: "", password: "", toktokSerial: "" });

    const req = async function (userId) {

        const reqSql = "/api/users/user/" + userId;
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.data.length > 0) {

                const user = res.data[0];
                let copyUserData = {
                    ...userData, username: user.username, name: user.name, email: user.email, phone: user.phone, address: user.address, subAddress: user.sub_address, password: user.pass, toktokSerial: user.user_key
                };
                setUserData(copyUserData);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");

                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    const resetFunc = function () {
        let copyOtpConfirm = { ...userLogin };
        copyOtpConfirm = { login_id: "", password: "", toktokSerial: "" };
        setUserLogin(copyOtpConfirm);
    };

    const submit = async function () {
        const login_id = userLogin.login_id;
        const password = userLogin.password;
        const toktokSerial = userLogin.toktokSerial;

        if (login_id === undefined || login_id === "" || password === undefined || password === "" || toktokSerial === undefined || toktokSerial === "") {
            alert("가입한 아이디/비밀번호/톡톡보드 톡톡박스 시리얼번호를 확인 하세요")
            return;
        }

        resetFunc();
        const reqSql = "/api/toktokbox";
        const params = { login_id, toktokSerial, password };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200 || res.status === 201) {
                alert("톡톡박스 시리얼번호가 등록 되었습니다.");
                window.location.href = "/";
            }else if(res.status === 205){
                alert("비밀번호가 틀렸습니다.");
            }else if(res.status === 206){
                alert("등록된 ID가 아닙니다.");
            } else {
                alert("잘못된 톡톡박스 시리얼번호 입니다.");
            }
        }).catch(function (err) {
            if (err.response.status === 409) {
                alert("이미 등록된 톡톡박스 시리얼번호 입니다.");
            } else if (err.response.status === 410) {
                alert("잘못된 톡톡박스 시리얼번호 입니다.");
            } else if (err.response.status === 411) {
                alert("등록할 수 없는 톡톡박스 시리얼번호 입니다.");
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        const id = sessionStorage.getItem("userId");
        if (Number(id) !== -1 && id !== null) {
            req(id);
        }
    }, [pathData.state]);

    return (
        <div>
            <div className="modal fade" id="toktokRegist" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="toktokRegist">톡톡박스 시리얼번호 등록</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                resetFunc();
                            }}></button>
                        </div>
                        <div className="modal-body">
                            <div className="sign-in">
                                <form  >
                                    <div className="form-group text-start">
                                        <label htmlFor="login_id" className="form-label mt-4">아이디:</label>
                                        <input type="text" className="form-control" placeholder="아이디를 입력해 주세요" name="login_id" value={userLogin.login_id} onChange={(e) => {
                                            let copyUserData = { ...userLogin };
                                            copyUserData.login_id = e.target.value;
                                            setUserLogin(copyUserData);
                                        }}></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="password" className="form-label mt-4">비밀번호:</label>
                                        <input type="password" className="form-control" placeholder="비밀번호를 입력해 주세요" name="password" value={userLogin.password} onChange={(e) => {
                                            let copyUserData = { ...userLogin };
                                            copyUserData.password = e.target.value;
                                            setUserLogin(copyUserData);
                                        }}></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="toktokSerial" className="form-label mt-4">톡톡박스 시리얼번호:</label>
                                        <input type="text" className="form-control" placeholder="톡톡박스 시리얼번호를 입력하세요" name="toktokSerial" value={userLogin.toktokSerial} onChange={(e) => {
                                            let copyUserData = { ...userLogin };
                                            copyUserData.toktokSerial = e.target.value;
                                            setUserLogin(copyUserData);
                                        }}></input>
                                    </div>
                                    <div className="form-group mt-4 row p-2">
                                        <button type="button" className="btn btn-lg btn-primary" data-bs-dismiss="modal" onClick={() => {
                                            submit();
                                        }}>톡톡박스 시리얼번호 등록</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}